import { ArrowDownIcon, ClosingIcon, DarkLogo, LightLogo, NavMenuIcon, PlayIcon } from "assests";
import { Button } from "components/UI/Button";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { clearAuthData } from "store/authenticationSlice";
import { collapseNavbar } from "store/navbarSlice";
import { removeQueryParam } from "utils/helper";
const Navbar = ({ redirectToSignin }) => {
  const { isDarkMode } = useSelector((state) => state.themeSlice);
  const { activeStep } = useSelector((state) => state.createAccountSlice);
  const url = window.location.href;
  const fromWeb = url.split("?")[1];
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showRequestDemo, isNavbarCollapsed } = useSelector((state) => state.navbarSlice);
  const handleRequestDemoClick = () => {
    if (!showRequestDemo) {
      dispatch(collapseNavbar());
    }
  };

  const [hasBorder, setHasBorder] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window && window.scrollY > 20) {
        setHasBorder(true);
      } else {
        setHasBorder(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLogOut = () => {
    dispatch(clearAuthData());
    dispatch({ type: "LOGOUT" });
    navigate(`/signin`, { replace: true });
  };

  return (
    <div>
      {isNavbarCollapsed && (
        <div
          className={`fixed  left-0 px-8 z-10 transition-all ease-in-out duration-300 w-full h-[72px] md:h-20  flex-col justify-center items-center gap-2.5 inline-flex ${location.pathname === "/signin" || (location.pathname === "/signup" && activeStep === 1) ? `bg-white ${hasBorder && "border-b border-global-gray-medium"} ` : ` bg-white  md:bg-transparent md:border-none ${hasBorder && "border-b border-global-gray-medium"}`} ${location.pathname === "/signin" ? "md:bg-transparent top-0 md:top-4 md:border-none" : "top-0"}`}
        >
          <div
            className={`w-full  px-8 h-full md:h-full  justify-center items-center flex max-w-[1280px]  ${location.pathname === "/signin" ? "bg-white rounded-2xl md:border md:border-global-divider-soft md:px-[60px]" : ""}`}
          >
            <div className="w-full justify-between items-center inline-flex">
              <div className=" justify-center flex-1 md:justify-start items-center gap-20 flex">
                <div>
                  {redirectToSignin ? (
                    <Button
                      onClick={handleLogOut}
                      variant="link"
                      className="flex justify-center cursor-pointer gap-3 p-0 m-0"
                    >
                      {isDarkMode ? <DarkLogo /> : <LightLogo />}
                    </Button>
                  ) : (
                    <Link to={"/"} className="flex justify-center cursor-pointer gap-3">
                      {isDarkMode ? <DarkLogo /> : <LightLogo />}
                    </Link>
                  )}
                </div>
              </div>

              <div className="hidden md:flex">
                {location.pathname === "/signin" && (
                  <div className="flex gap-4 items-center">
                    {/* <Link
                      to={`${process.env.REACT_APP_WEB_URL}/request-demo`}
                      target="_blank"
                      rel="noreferrer"
                    > */}
                    <Button
                      className="h-[44px] text-base px-4 w-[173px] font-semibold rounded-lg cursor-not-allowed"
                      isDisabled={true}
                    >
                      Request Demo <PlayIcon />
                    </Button>
                    {/* </Link> */}
                    {fromWeb && (
                      <div onClick={() => removeQueryParam(["fromWeb"], location, navigate)}>
                        <Link to={`${process.env.REACT_APP_WEB_URL}`} rel="noreferrer">
                          <Button className="h-[44px] text-base px-4 w-[90px] text-login-text-title font-semibold rounded-lg bg-btn-gray-extra hover:text-white">
                            Back
                          </Button>
                        </Link>
                      </div>
                    )}
                  </div>
                )}
                {location.pathname === "/signup" && activeStep === 1 && (
                  <div className="flex items-center justify-center">
                    <p className="relative z-10 pl-2 pr-1 text-base font-normal text-login-global-title whitespace-nowrap">
                      Already have an account?
                    </p>
                    <Link
                      to="/signin"
                      className="p-0 m-0 pr-2 bg-transparent  text-base font-semibold  text-btn-text-link hover:text-global-primary whitespace-nowrap "
                    >
                      Log in
                    </Link>
                  </div>
                )}
              </div>
              {location.pathname === "/signin" && (
                <div className="flex justify-end  md:hidden">
                  <div onClick={() => dispatch(collapseNavbar())} className="cursor-pointer">
                    {isNavbarCollapsed ? (
                      <NavMenuIcon width={24} height={24} />
                    ) : (
                      <ClosingIcon width={24} height={24} />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {!isNavbarCollapsed && (
        <div className="fixed z-50 left-0 top-0 h-full w-full  bg-white">
          <div
            className={`fixed top-0 left-0 z-10 transition-all ease-in-out duration-300 w-full h-[72px] md:h-20  flex-col justify-center items-center gap-2.5 inline-flex ${location.pathname === "/signin" || (location.pathname === "/signup" && activeStep === 1) ? `bg-white border-b border-global-gray-medium` : ` bg-white md:bg-transparent md:border-none border-b border-global-gray-medium `}`}
          >
            <div className="w-full h-11 px-8 justify-center items-center flex">
              <div className="w-full justify-between items-center inline-flex">
                <div className=" justify-start flex-1 md:justify-start items-center gap-20 flex">
                  <div>
                    <Link to={"/"} className="flex justify-center cursor-pointer gap-3">
                      {isDarkMode ? <DarkLogo /> : <LightLogo />}
                    </Link>
                  </div>
                </div>

                {location.pathname === "/signin" && (
                  <div className="flex justify-end  md:hidden">
                    <div onClick={() => dispatch(collapseNavbar())} className="cursor-pointer">
                      {isNavbarCollapsed ? (
                        <NavMenuIcon width={24} height={24} />
                      ) : (
                        <ClosingIcon width={24} height={24} />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center justify-start relative transition-all duration-300 pt-[72px]">
            <div className="grid grid-cols-1 w-full md:w-auto gap-4  p-8">
              {location.pathname === "/signin" && (
                <>
                  {/* <Link
                    to={`${process.env.REACT_APP_WEB_URL}/request-demo`}
                    target="_blank"
                    rel="noreferrer"
                  > */}
                  <Button
                    onClick={handleRequestDemoClick}
                    className="h-[44px] text-base  px-4 w-full font-semibold rounded-lg cursor-not-allowed"
                    isDisabled={true}
                  >
                    Request Demo <PlayIcon />
                  </Button>
                  {/* </Link> */}

                  {fromWeb && (
                    <div onClick={() => removeQueryParam(["fromWeb"], location, navigate)}>
                      {/* <Link to={`${process.env.REACT_APP_WEB_URL}`} rel="noreferrer"> */}
                      <Button className="h-[44px] text-base px-4 w-full text-login-text-title font-semibold rounded-lg bg-btn-gray-extra hover:text-white">
                        Back
                      </Button>
                      {/* </Link> */}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
